export default {
	data(){
		return {
			tableGBoptions: { 
				options: {eliminar: 'Eliminar inclusión'},
				modals: [
					{
						modal: "Radicado",
						icon: "check-circle",
						title: "Radicado de la Inclusión"
					  },
				]
			},

			tableGBSearch: ['datos_afiliado/name','afiliado_inclusiones/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Titular', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Beneficiario', sort: null, sortTable: 'afiliado_inclusiones/name'},
					tbody: { td: ['afiliado_inclusiones/name'],}
				},
				{
					thead: { th: 'Dirección', },
					tbody: { td: ['afiliado_inclusiones/direccion'],}
				},
				{
					thead: { th: 'Documento', },
					tbody: { td: ['afiliado_inclusiones/archivo'], link:'/files', archivo: true}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
				},
			],	
			

			tableGBHISTSearch: ['datos_afiliado/name','afiliado_inclusiones/name'],
			
			tableGBHISTItems: [
				{
					thead: { th: 'Titular', sort: null, sortTable: 'datos_afiliado/name'},
					tbody: { td: ['datos_afiliado/name'],}
				},
				{
					thead: { th: 'Beneficiario', sort: null, sortTable: 'afiliado_inclusiones/name'},
					tbody: { td: ['afiliado_inclusiones/name'],}
				},
				{
					thead: { th: 'Dirección', },
					tbody: { td: ['afiliado_inclusiones/direccion'],}
				},
				{
					thead: { th: 'Documento', },
					tbody: { td: ['afiliado_inclusiones/archivo'], link:'/files', archivo: true}
				},
				{
					thead: { th: 'Radicado', },
					tbody: { td: ['afiliado_inclusiones/archivo_radicado'], link:'/files', archivo: true}
				},
				{
					thead: { th: 'Radicador', },
					tbody: { td: ['list_users/name'], ftn: function(value) { return value.split(' ')[0]}}
				},
			],		
		
		}
	},
}